<div id="dragQuestion" class="linkingQuestion"  #dragQuestion>
  <div id="linkWrapper" class="row col-12">
    <div class="divGauche col-4 col-md-5">
      <ul id="dragUL" class="w-100" #dragUL>

        <li *ngFor="let option of optionGauche">
          <div class="row w-100 ml-0 mb-3">

            <button  *ngIf="mode==ModeQuestion.create" class="btn  btn-danger btn-circle" (click)="deleteOption(option)"  title="{{'deleteOption' | trad}}"><i class="fa fa-trash"></i></button>



            <input class="col-10" *ngIf="mode==ModeQuestion.create" type="text" [(ngModel)]="option.text" />
            <div class="col-11 text-right" *ngIf="displayMode  || mode==ModeQuestion.reply">{{option.text}}</div>

            <div id="{{option.ident}}" class="dragElement" draggable="true" [attr.idColor]="option.ctrlType" #dragElement><i class="far fa-circle"></i></div>
          </div>
        </li>

        <li *ngIf="mode==ModeQuestion.create" class="pr-5 text-center">
          <button class="btn btn-circle" title="Ajouter une option" (click)="addOption('Gauche')"><i class="fa fa-plus"></i></button>
        </li>
      </ul>

    </div>
    <div class="canvasWrapper col-4 col-md-2" #canvasWrapper>
      <canvas id="canvas" #canvas></canvas>
      <canvas id="canvasTemp" #canvasDrag></canvas>
    </div>

    <div class="divDroit col-4 col-md-5">
      <ul id="dropUL" class="w-100" #dropUL>

        <li *ngFor="let option of optionDroit">

          <div class="row w-100 ml-0 mb-3">
            <div id="{{option.ident}}" (click)="clearPath($event)" class="dropElement" attr.option="option" #dropElement><i class="far fa-circle"></i></div>

            <input [ngClass]="{'col-9': noteQuestion,'col-7': !noteQuestion}" class="offset-1" *ngIf="mode==ModeQuestion.create" type="text" [(ngModel)]="option.text" />
            <div class="offset-1 col-9" *ngIf="displayMode || mode==ModeQuestion.reply">{{option.text}}</div>



            <input class="offset-1 col-2 point" *ngIf="mode==ModeQuestion.create && !noteQuestion" type="text" placeholder="{{'point' | trad}}" [(ngModel)]="option.point" (ngModelChange)="getMaxNote()" />

            <button *ngIf="mode==ModeQuestion.create" class="btn  btn-danger btn-circle" (click)="deleteOption(option)" title="{{'deleteOption' | trad}}"><i class="fa fa-trash"></i></button>

          </div>

        </li>
       
        <li *ngIf="mode==ModeQuestion.create" class="pl-5 text-center">
          <button class="btn btn-circle" title="Ajouter une option" (click)="addOption('Droit')"><i class="fa fa-plus"></i></button>
        </li>
      </ul>
    </div>
  </div>
</div>
